import { useMutation, useQueryClient } from "@tanstack/react-query";
import { http } from "../../utils";

async function completeDelivery(productOrderId) {
  const data = await http(`/admin/product-order-complete-delivery`, {
    data: {
      productOrderId,
    },
  });
  return data;
}

export function useCompleteDelivery() {
  const queryClient = useQueryClient();

  return useMutation(completeDelivery, {
    onSuccess: () => {
      queryClient.refetchQueries(["product-order-parents"]);
    },
  });
}
